<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb></breadcrumb>
      <el-dropdown class="avatar-container">
        <div class="avatar-wrapper">
          <!-- <img style="width:35px;height:35px" src="../../../assets/image/boy.png" alt=""> -->
          <span style="color: #333">欢迎您 , &nbsp;&nbsp;{{ name }}</span>
          <i class="el-icon-arrow-down el-icon--right left1"></i>

        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown" trigger="hover">
          <el-dropdown-item divided>
            <span style="display: block">部门：{{ departmentName }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="editPwd" style="display: block">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="logout" style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>

    <!-- <div class="header2">
      <div class="left">客服管理</div>
      <div class="right">
        <div>账号：<span>{{ name }}</span></div>
        <div>部门：<span>客服</span></div>
      </div>
    </div> -->

    <div>
      <el-dialog title="修改密码" :visible.sync="dialogFormVisible" @close="closeFrom">
        <el-form :model="ruleForm" status-icon label-width="130px" width="50%" ref="ruleForm" class="demo-ruleForm"
          :rules="rules">
          <el-form-item label="当前密码" prop="oldpassword">
            <el-input type="password" v-model="ruleForm.oldpassword" autocomplete="off" class="left2" maxlength="20" minlength="6">
            </el-input>
          </el-form-item>
          <el-form-item label="修改密码" prop="password">
            <el-input type="password" v-model="ruleForm.password" autocomplete="off" class="left2" maxlength="20" minlength="6"></el-input>
          </el-form-item>
          <el-form-item label="二次密码" prop="confirmpassword">
            <el-input type="password" v-model="ruleForm.confirmpassword" autocomplete="off"
              style="width: 320px;" maxlength="20" minlength="6"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('ruleForm')">重置</el-button>
          <el-button @click="closeFrom">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";


export default {
  data() {
    var validatejPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        if (this.ruleForm.oldpassword !== "") {
          this.$refs.ruleForm.validateField("oldpassword");
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "" || value.length < 6) {
        callback(new Error("请输入密码不能小于6位"));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.ruleForm.validateField("password");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,  //修改密码弹窗
      name: "",
      departmentId: '',
      departmentName: '',

      ruleForm: {
        username: "",
        oldpassword: "",
        password: "",
        confirmpassword: "",
      },


      // 页面id
      ypid1: "30",
      ypid2: "27",
      ypid3: "28",
      ypid4: "26",


      rules: {
        oldpassword: [
          { required: true, message: '旧密码不能为空', trigger: "blur" },
          {
            required: true,
            pattern: /^[0-9A-Za-z]{6,20}$/,
            message: "请输入6到20位数字加字母组合", trigger: ["change", "blur"]
          },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: "blur" },
          {
            required: true,
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
            message: "请输入6到20位数字加字母组合", trigger: ["change", "blur"]
          },
        ],
        confirmpassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },

    };
  },
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
  },

  created() {


    this.name = localStorage.getItem("realname")
      ? localStorage.getItem("realname")
      : "";

    this.departmentId = localStorage.getItem("departmentId")
      ? localStorage.getItem("departmentId")
      : "";

    this.ruleForm.id = localStorage.getItem("id");
    this.ruleForm.username = localStorage.getItem("username");

    //部门
    this.$api.get("/sys/department/getSelect").then((res) => {
      if ((res.data.success = true)) {
        res.data.result.forEach(item => {
          if (this.departmentId == item.id) {
            this.departmentName = item.departmentName;
          }
        })

      }
    });

  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },


    //修改密码
    editPwd() {
      this.dialogFormVisible = true;
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let obj = {
            username: this.ruleForm.username,
            oldpassword: this.ruleForm.oldpassword,
            password: this.ruleForm.password,
            confirmpassword: this.ruleForm.confirmpassword,

          };
          this.$api.put("/sys/user/updatePassword", obj, true).then((res) => {
            if (res.data.success == true) {
              this.$message({
                message: "密码修改成功",
                type: "success",
              });
              this.closeFrom()
              this.$router.push({ path: "/login" });
              window.localStorage.removeItem('token');
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.ruleForm.oldpassword = '';
      this.ruleForm.password = '';
      this.ruleForm.confirmpassword = '';
    },

    closeFrom() {
      this.ruleForm.oldpassword = '';
      this.ruleForm.password = '';
      this.ruleForm.confirmpassword = '';
      this.dialogFormVisible = false
    },

    // 注销
    logout() {
      this.$confirm("真的要退出登录吗 ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ path: "/login" });
          window.localStorage.removeItem('token');
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //跳转界面
    compile(i) {
      if (i == 1) {
        this.$router.push({
          name: "PersonalInformationManagement",
          params: { ypid1: this.ypid1 },
        });
      } else if (i == 2) {
        this.$router.push({
          name: "MyTasks",
          params: { ypid2: this.ypid2 },
        });
      } else if (i == 3) {
        this.$router.push({
          name: "PatientInformationManagement",
          params: { ypid3: this.ypid3 },
        });
      } else if (i == 4) {
        this.$router.push({
          name: "PatientInformationInput",
          params: { ypid4: this.ypid4 },
        });
      }
    },


  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 55px;
  line-height: 55px;
  border-radius: 0px !important;
  display: flex;
  // background-color: rgb(30, 68, 238);
  position: relative;

  .hamburger-container {
    float: left;
    padding: 0 10px;
  }
}


.avatar-container {
  height: 50px;
  display: inline-block;
  position: absolute;
  right: 35px;

  .avatar-wrapper {
    cursor: pointer;
    margin-top: 5px;
    position: relative;

    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 10px;
    }

    .el-icon-caret-bottom {
      position: absolute;
      right: -20px;
      top: 25px;
      font-size: 12px;
    }
  }
}

.header {
  display: flex;
  position: absolute;
  right: 200px;
  height: 80px;
  line-height: 80px;
}

.header .topTitle {
  margin: 0 15px;
  text-align: center;
  width: 80px;
}

.header .topTitle img {
  width: 50px;
  height: 30px;
}

.header .topTitle .title {
  margin-top: -60px;
}



//第二部分
.header2 {
  height: 50px;
  display: flex;
  line-height: 50px;
}

.header2 .left {
  background-color: aqua;
  width: 10%;
  text-align: center;
}

.header2 .right {
  width: 90%;
  background-color: beige;
  display: flex;
  justify-content: end;
  padding-right: 220px;
}

.header2 .right div:nth-child(1) {
  margin-right: 55px;
}


.left1{
  margin-bottom: 10px;
}

.left2{
  width: 320px;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue